import React, { PropsWithChildren } from 'react';
import { WaitingIcon } from '../../WaitingIcon/WaitingIcon';
import { Body, BodyHeader, Container, Footer, Header } from './styles';

interface IBodySectionPage {
  header?: React.ReactNode[];
  padding?: string;
  backgroundColor?: string;
}

interface IMultipleSectionPage {
  items: React.ReactNode[];
  padding?: string;
  backgroundColor?: string;
}

interface ISectionsPageProps {
  header?: IMultipleSectionPage;
  body: IBodySectionPage;
  footer?: IMultipleSectionPage;
  loading?: boolean;
}

export const SectionsPage: React.FC<PropsWithChildren<ISectionsPageProps>> = ({
  header,
  body,
  footer,
  children,
  loading
}) => {

  const [dimensions, setDimensions] = React.useState({
    screenHeight: window.screen.height,
    windowHeight: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
  });
  const [headerHeight, setHeaderHeight] = React.useState<number|undefined|null>(undefined);
  const [bodyHeaderHeight, setBodyHeaderHeight] = React.useState<number|undefined|null>(undefined);
  const [footerHeight, setFooterHeight] = React.useState<number|undefined|null>(undefined);
  const headerRef = React.useRef<any>(null);
  const bodyHeaderRef = React.useRef<any>(null);
  const footerRef = React.useRef<any>(null);

  React.useEffect(() => {
    function handleResize() {
      setTimeout(() => {
        setDimensions({
          screenHeight: window.screen.height,
          windowHeight: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
        });
        setHeaderHeight(headerRef?.current?.offsetHeight);
        setBodyHeaderHeight(bodyHeaderRef?.current?.offsetHeight);
        setFooterHeight(footerRef?.current?.offsetHeight);
      }, 100);
    };

    setHeaderHeight(headerRef?.current?.offsetHeight);
    setBodyHeaderHeight(bodyHeaderRef?.current?.offsetHeight);
    setFooterHeight(footerRef?.current?.offsetHeight);

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    }
  }, []);

  let headerHeightPx = '';
  if (headerHeight !== undefined && headerHeight !== null) {
    headerHeightPx = `${headerHeight}px`;
  }
  let bodyHeaderHeightPx = '';
  if (bodyHeaderHeight !== undefined && bodyHeaderHeight !== null) {
    bodyHeaderHeightPx = `${bodyHeaderHeight}px`;
  }
  let footerHeightPx = '';
  if (footerHeight !== undefined && footerHeight !== null) {
    footerHeightPx = `${footerHeight}px`;
  }
  
  const bodyHeaderTop = (headerHeight || 0);
  const bodyHeaderTopPx = `${bodyHeaderTop}px`;

  const bodyTop = (headerHeight || 0) + (bodyHeaderHeight || 0);
  const bodyTopPx = `${bodyTop}px`;

  return (
    <Container>
      <Header
        ref={headerRef}
        padding={header?.padding}
        backgroundColor={header?.backgroundColor}
      >{header?.items?.map((item, index) => <div key={`sections_page_header_item_${index}`}>{item}</div>)}</Header>

      {body?.header && body?.header.length > 0 ?
      <BodyHeader
        ref={bodyHeaderRef}
        top={bodyHeaderTopPx}
        data-top={bodyHeaderTopPx}
        padding={body?.padding}
        backgroundColor={body?.backgroundColor}
      >{body?.header?.map((item, index) => <div key={`sections_page_body_header_item_${index}`}>{item}</div>)}</BodyHeader>
      : null}

      <Body
        top={bodyTopPx}
        data-top={bodyTopPx}
        height={headerHeightPx || bodyHeaderHeightPx || footerHeightPx 
          ? `calc(100vh${headerHeightPx ? ' - ' + headerHeightPx : ''}${bodyHeaderHeightPx ? ' - ' + bodyHeaderHeightPx : ''}${footerHeightPx ? ' - ' + footerHeightPx : ''} - 10px)`
          : '0px'}
        padding={body?.padding}
        backgroundColor={body?.backgroundColor}
      >{loading ? <WaitingIcon /> : children}</Body>

      {footer && 
      <Footer
        ref={footerRef}
        padding={footer?.padding}
        backgroundColor={footer?.backgroundColor}
      >{footer?.items?.map((item, index) => <div key={`sections_page_footer_item_${index}`}>{item}</div>)}</Footer>}
    </Container>
  );
}